import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import Axios from "./../../../../utils/api/axiosConf";
import { url } from "../../../../utils/api/api";
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import BUTTON from "./../../../../components/buttons/button";
import TEXTROW from "../../../../components/textRow";
import LOADING from "../../../../components/loading/loading";
import INPUT from "./../../../../components/input/input";
import UPLOAD from "./../../../../components/uoload/upload";
import { Uploder } from "../../../../utils/utils";
import noPhoto from './../../../../assets/images/noPhoto.jpeg';
import { color } from "./../../../../utils/themes/color";
import recycleImg from "./../../../../assets/images/recycleBin.jpg";
import { Pagination } from 'antd';




export default function Deposit(props) {

    const userId = props.userId
    const [loading, setLoading] = useState({ 1: false, 2: false, 3: false, 4: false });
    const [user, setUser] = useState({});
    const [inventory, setInventory] = useState({});
    const [updator, setUpdator] = useState(1)


    useEffect(() => {
        setLoading({ ...loading, 3: true })
        Axios.get(`${url}withdraw/get-user-wallet-amount?userId=${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setInventory(response.data)
                    setLoading({ ...loading, 3: false })
                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 3: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])


    const updateDeposit = () => {

        if (user.amount != "" && user.amount != null && user.amount != undefined) {

            var x = {
                amount: user.amount,
                userId: userId
            }

            setLoading({ ...loading, 1: true })
            Axios.post(`${url}withdraw/add-money-to-user-wallet`, x)
                .then(async (response) => {

                    if (response.status === 200 || response.status === 201) {
                        setUpdator(updator + 1)
                        GreenNotif(response.message);
                        setLoading({ ...loading, 1: false })
                    } else {
                        RedNotif(response.message);
                        setLoading({ ...loading, 1: false })
                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading({ ...loading, 1: false })
                });

        } else {
            RedNotif("مقدار نمیتواند خالی باشد")
        }
    }


    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px' }}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <p>اطلاعات برداشت را وارد نمایید:</p>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ justifyContent: 'left', alignItems: 'left', display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p style={{ color: color.primary, fontSize: "20px", padding: '4px' }}>موجودی:</p>
                            <p style={{ fontSize: "20px", padding: '4px' }}>{inventory.amount}تومان</p>
                        </div>
                    </Col>
                </Row>

                <Row style={{ marginRight: '8px' }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>مقدار:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <INPUT
                            placeholder="مبلغ را به تومان وارد کنید"
                            i={(e) => setUser({ ...user, "amount": e })}
                            value={user.amount != undefined && user.amount != null && user.amount != "0" ? user.amount : ""}
                        />
                    </Col>
                </Row>

                <Row style={{ marginTop: '64px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => updateDeposit()}
                            text="افزودن مقدار به کیف پول"
                            type={"submit"}
                            loading={loading[2]} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON text="رد کردن" type={"cancel"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }

}